import React, { useContext, useEffect, useState } from 'react';

import { useHistory, Link } from 'react-router-dom';

import MUIDataTable from "mui-datatables";
import { Chip, IconButton, Typography } from '@mui/material';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faClipboardList, faEdit, faListAlt, faPlay, faTrash, faTrashAlt } from '@fortawesome/free-solid-svg-icons';
import DeleteDialog from '../../../../../components/DeleteDialog';


//export default class TablaProductos extends Component
export default function AttributesValuesDataTable({attributesValues, onDelete, isLoading})
{
    const [attributeValueToRemove,setAttributeValueToRemove] = useState(null);
    const [openDeleteDialog,setOpenDeleteDialog] = useState(false);

    const handleOpenDialog = (attributeValue) => {
        setAttributeValueToRemove(attributeValue);
        setOpenDeleteDialog(true);
    }

    const columns = [
        {
            name : 'id',
            label : 'ID',
        },
        {
            name : 'value',
            label : 'Valor',
        },
        {
            name : 'description',
            label : 'Descripción',
        },
        {
            name : 'additiona_value',
            label : 'Valor Adicional',
            options : 
            {
                customBodyRenderLite : (dataIndex) => {
                    if(attributesValues[dataIndex].additiona_value)
                    {
                        return <Typography>${attributesValues[dataIndex].additiona_value}</Typography>
                    }
                    else
                    {
                        return <Typography>N/A</Typography>
                    }
                        
                },
                    //let id = subCategorias[dataIndex].idSubCategoria;
                filter:false
            }
        },
        {
            name : '',
            label : 'Acciones',
            options : 
            {
                customBodyRenderLite : (dataIndex) => {
                    //let id = attributesValues[dataIndex].idSubCategoria;
                    return(
                        <div style={{display:'flex',flexDirection:'row',justifyContent:'center'}}>
                            <Link 
                                to={'/products/attributesValues/update/'+attributesValues[dataIndex].id} 
                                ///products/attributesValues/update/:attributeValueId
                                //onClick={ ()=> localStorage.setItem('categoria',JSON.stringify(attributesValues[dataIndex])) }
                                replace
                            >
                                <IconButton>
                                    <FontAwesomeIcon icon={faEdit}/>
                                </IconButton>
                            </Link>

                            <IconButton color='error' onClick={()=>handleOpenDialog(attributesValues[dataIndex])}>
                                <FontAwesomeIcon icon={faTrashAlt}/>
                            </IconButton>
                        </div>
                    );
                },

                print : false
            }
        }
    ];


    const options = {
        filterType: 'checkbox',
        selectableRows: 'none',
      };


    return(
        <>
            <MUIDataTable
                title={"Listado de Valores del atributo"}
                data={attributesValues}
                columns={columns}
                options={options}
            />
            <DeleteDialog
                open={openDeleteDialog}
                title={'Eliminar valor de atributo'}
                message={'¿Está seguro que desea eliminar el valor de atributo "'+ (attributeValueToRemove ? attributeValueToRemove.value : '') +'"? Esta acción no se puede deshacer.'}
                isLoading={isLoading}
                onClose={ ()=> setOpenDeleteDialog(false) }
                onConfirm={ async () => {
                    await onDelete(attributeValueToRemove.id);
                    setOpenDeleteDialog(false);
                } }
            />
        </>
    )
}